/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import {TranslateService} from '@ngx-translate/core';

import {LocalNetworkProfile} from '../../../../components/session/local-network-profile';
import {buildStateTitle} from './state-title';
import {WINDOW} from '../../../angular-platform-providers';
import {AdnInterpolateService} from '../../filters/adn-interpolate';
import {ApiConfig} from '../../../config/api-config';
import {LocalNetworkInfo} from '../../../../components/session/local-network-info';

@Component({
  standalone: true,
  selector: 'adn-state-title',
  template: '<h1>{{title}}</h1>'
})
export class StateTitleComponent implements OnInit, OnDestroy {
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() separator = ' - ';
  @Input() stateDataProperty = 'title';
  @Input() hideSuffix = false;

  title = '';
  private deregisterTransition: (() => void) | null = null;

  constructor(
    private readonly uiRouter: UIRouter,
    private readonly localNetworkProfile: LocalNetworkProfile,
    private readonly translateService: TranslateService,
    private readonly interpolate: AdnInterpolateService,
    @Inject(WINDOW) private readonly window: Window,
    private readonly apiConfig: ApiConfig,
    private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
    this.deregisterTransition = this.uiRouter.transitionService.onSuccess({}, () => this.updateTitle()) as () => void;
  }

  ngOnDestroy(): void {
    this.deregisterTransition?.();
  }

  private updateTitle(): void {
    const currentState = (this.uiRouter.stateService as any).$current || this.uiRouter.globals.current;
    if (!currentState?.name) {
      return;
    }
    this.title = buildStateTitle({
      currentState,
      dataPropertyPath: 'data.' + this.stateDataProperty,
      prefix: this.prefix,
      suffix: this.suffix,
      separator: this.separator,
      hideSuffix: this.hideSuffix,
      window: this.window,
      apiConfig: this.apiConfig,
      localNetworkInfo: this.localNetworkInfo,
      getNetworkTranslations: title => this.localNetworkProfile.getNetworkTranslations(title),
      translateInstant: key => this.translateService.instant(key),
      interpolate: template => this.interpolate.compile(template)
    });
  }
}

export function stateTitleView(): any {
  return {
    component: StateTitleComponent
  };
}
